import * as t from 'io-ts';
import {mapValues} from 'lodash';

/*
 * Runtime type.
 */

const RTeammateAccessItem = t.readonly(
  t.type({
    roles: t.readonlyArray(t.string),
  }),
);

export const RTeammateAccess = t.readonly(
  t.dictionary(t.string, t.union([RTeammateAccessItem, t.undefined])),
);

/*
 * Type.
 */

export interface TeammateAccessModel extends t.TypeOf<typeof RTeammateAccess> {}

/*
 * IO methods.
 */

export function parseTeammateAccess(src: any): TeammateAccessModel {
  return mapValues(src, (i) => ({
    roles: i.roles,
  }));
}
